import { ArrowUpRightIcon } from '@heroicons/react/24/outline';
import { GQLCalloutCtaFragment } from '@theprintbar/graphql';
import { BrandStarAnimated, OutlineLinkButton } from '@theprintbar/ui';
import { CTAText } from './CTAText';

interface CalloutCTAProps {
	content: Pick<GQLCalloutCtaFragment, 'calloutCTA'>;
}

export function CalloutCTA({ content }: CalloutCTAProps) {
	if (!content.calloutCTA.structure) return null;

	const { title, text, link } = content.calloutCTA.structure;
	return (
		<div className="bg-blue-bright rounded-3xl border border-blue p-8 space-y-4 flex flex-col lg:flex-row justify-between lg:space-y-0">
			<div className="space-y-2.5">
				<div className="flex items-center">
					<BrandStarAnimated className="h-4 w-4 fill-blue mr-4" />
					<h4 className="uppercase text-base lg:text-lg">{title}</h4>
				</div>
				<CTAText className="lg:text-base text-sm" text={text} />
			</div>
			{link?.text && (
				<OutlineLinkButton to={(link && link.to) || '/'} icon={ArrowUpRightIcon} className="w-fit whitespace-nowrap h-fit">
					<h5 className="text-xs uppercase">{link ? link.text : 'Learn More'}</h5>
				</OutlineLinkButton>
			)}
		</div>
	);
}
